import { CoverageAreaProps } from "store/modules/Logistics/types.store";

export const WEEK_DAYS = {
  "0": "Monday",
  "1": "Tuesday",
  "2": "Wednesday",
  "3": "Thursday",
  "4": "Friday",
  "5": "Saturday",
  "6": "Sunday",
} as const;

export type WeekDayKey = keyof typeof WEEK_DAYS;
export type WeekDayName = (typeof WEEK_DAYS)[WeekDayKey];

export interface DayData {
  enabled: boolean;
  isOpen: boolean;
  open: string;
  close: string;
}

export interface MassEditWorkingHoursFormData {
  days: Record<WeekDayKey, DayData>;
  holiday: DayData;
}

export interface SelectedDayInfo {
  day: string;
  dayName: string;
  isOpen: boolean;
  open: string;
  close: string;
}

export interface MassEditWorkingHoursMenuProps {
  handleCloseMassEditWorkingHours: () => void;
  massEditData: CoverageAreaProps[];
}
